/**
 * Sets all the screens of the app under their respective routes.
 */

/** */
import React from "react";
import { HashRouter as Router, Switch, Route, useHistory } from "react-router-dom";
import Loadable from "react-loadable";
import {
    COMPLETE_DEFAULT_SIGNUP_ROUTE,
    LOGIN_ROUTE,
    LOGOUT_ROUTE,
    SIGNUP_ROUTE,
    COMPLETE_DEALER_GROUP_SIGNUP_ROUTE,
    ORG_AUTHORIZE_ROUTE,
    SIGNUP_DEALER_GROUP_ROUTE,
    SIGNUP_DEFAULT_PLANNER_ROUTE,
} from "../constants/appRoutes";
import RouteComponentHOC from "./routeHelpers/RouteComponent";
import LoginPage from "../pages/Authentication/Login/Login";
import RequiresAuth from "./routeHelpers/RequiresAuth";
import RequiresNoAuth from "./routeHelpers/RequiresNoAuth";
import LogoutPage from "../pages/Authentication/Logout/Logout";
import SignupPage, { SignupDealerGroup, SignupDefaultPlanner } from "../pages/Authentication/Signup/Signup";
import CompleteDefaultSignup from "../pages/Authentication/CompleteSignup/CompleteDefaultSignup";
import CheckAuth from "../pages/Authentication/CheckAuth/CheckAuth";
import { AppStoreActions } from "../redux/services/app/actions";
// import ContactFormCompletePage from "../pages/ExternalPages/ContactFormCompletePage/ContactFormCompletePage";
// import ContactDocumentSignPage from "../pages/ExternalPages/ContactDocumentSignPage/ContactDocumentSignPage";
import CompleteDealerGroupSignup from "../pages/Authentication/CompleteSignup/CompleteDealerGroupSignup";
import { APP_ENV } from "../constants/appVars";
import OrgAuthorize from "../pages/Authentication/Protected/OrgAuthorize/OrgAuthorize";

const GlobalRouterProvider = () => {
    const history = useHistory();
    AppStoreActions.saveRouterHistory(history);
    return <></>;
};

const AppRoutes = () => {
    return (
        <Router>
            <GlobalRouterProvider />
            <Switch>
                <Route path={LOGIN_ROUTE} component={RequiresNoAuth(LoginPage)} />
                <Route path={LOGOUT_ROUTE} component={RouteComponentHOC(LogoutPage)} />
                <Route path={SIGNUP_DEALER_GROUP_ROUTE} component={RouteComponentHOC(SignupDealerGroup)} />
                <Route path={SIGNUP_DEFAULT_PLANNER_ROUTE} component={RouteComponentHOC(SignupDefaultPlanner)} />
                <Route path={COMPLETE_DEFAULT_SIGNUP_ROUTE} component={RouteComponentHOC(CompleteDefaultSignup)} />
                <Route path={COMPLETE_DEALER_GROUP_SIGNUP_ROUTE} component={RouteComponentHOC(CompleteDealerGroupSignup)} />
                <Route path={SIGNUP_ROUTE} component={RouteComponentHOC(SignupPage)} />
                <Route path={ORG_AUTHORIZE_ROUTE} component={RequiresAuth(OrgAuthorize)} />
                <Route component={RouteComponentHOC(CheckAuth)} />
            </Switch>
        </Router>
    );
};

export default AppRoutes;
